import SimpleCrudList from "../../components/crud/SimpleCrudList";

interface RideReview {
  id: string;
  rating: number;
  reviewText: string;
  status: boolean;
}

export default function RideReviews() {
  return (
    <SimpleCrudList<RideReview>
      title="Ratings"
      apiPath="/ride-reviews"
      baseRoute="/ride-reviews"
      searchKeys={["reviewText"]}
      columns={[
        { key: "rating", label: "Rating", render: (r) => `${r.rating} ★` },
        { key: "reviewText", label: "Review" },
        { key: "status", label: "Active", render: (r) => (r.status ? "Yes" : "No") },
      ]}
      addLabel="Add Review"
    />
  );
}
